import CruciblePiece from './cruciblePiece';
import * as config from '../config.json';
import { FrameConfig } from '../config';
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader';

export class Frame extends CruciblePiece {
  protected _config: FrameConfig;
  constructor() {
    super();
    this._config = config.frame;
  }

  setup(gltf: GLTF) {
    this.group = gltf.scene;
    this.group.scale.set(0.02, 0.02, 0.02); // This should be removed with final models

    this.group.traverse((node: any) => {
      if (node.isMesh) {
        node.castShadow = true;
        node.receiveShadow = true;
        if (node.material.map) node.material.map.anisotropy = 16;
      }
    });
  }
}
